/**
 * proxyAsset(url) — auto-route a remote CDN URL through our own backend
 * so it's not blocked by ad-blockers, iCloud Private Relay, iOS preview
 * panes, or corporate firewalls.
 *
 * Use it on the splash + any other page that loads images from
 * customer-assets.emergentagent.com or other third-party CDNs.
 *
 *   <img src={proxyAsset(s.logo_image_url)} />
 *
 * If the URL is already same-origin, blank, a data: URL, or already
 * pointed at our backend, it's returned unchanged.
 */

const PROXY_HOSTS = [
  "emergentagent.com",
  "amazonaws.com",
  "cloudinary.com",
  "unsplash.com",
];

export function proxyAsset(url) {
  if (!url || typeof url !== "string") return url;
  if (url.startsWith("data:") || url.startsWith("blob:")) return url;
  // Skip relative paths and same-origin URLs
  if (!/^https?:\/\//i.test(url)) return url;
  try {
    const u = new URL(url);
    const host = (u.hostname || "").toLowerCase();
    const matches = PROXY_HOSTS.some((suffix) => host === suffix || host.endsWith(`.${suffix}`));
    if (!matches) return url;
    const backend = process.env.REACT_APP_BACKEND_URL || "";
    return `${backend}/api/asset-proxy?u=${encodeURIComponent(url)}`;
  } catch {
    return url;
  }
}

export default proxyAsset;
